module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisualizationLayerShown),
      expression: "isVisualizationLayerShown"
    }],
    attrs: {
      "transform": _vm.spotPosition
    }
  }, [_c('g', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showDetail($event)
      }
    }
  }, [(_vm.isRestroom && _vm.spot.gender === 'male') ? _c('visualization-pin-restroom-male', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.visualizationPinSize.width,
      "height": _vm.visualizationPinSize.height,
      "transform": _vm.visualizationPinTransform,
      "is-searched": _vm.isVisualizationPinSearched,
      "is-selected": _vm.isVisualizationPinSelected
    }
  }) : (_vm.isRestroom && _vm.spot.gender === 'female') ? _c('visualization-pin-restroom-female', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.visualizationPinSize.width,
      "height": _vm.visualizationPinSize.height,
      "transform": _vm.visualizationPinTransform,
      "is-searched": _vm.isVisualizationPinSearched,
      "is-selected": _vm.isVisualizationPinSelected
    }
  }) : (_vm.isRestroom && _vm.spot.gender === 'shared') ? _c('visualization-pin-restroom-shared', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.visualizationPinSize.width,
      "height": _vm.visualizationPinSize.height,
      "transform": _vm.visualizationPinTransform,
      "is-searched": _vm.isVisualizationPinSearched,
      "is-selected": _vm.isVisualizationPinSelected
    }
  }) : (_vm.spot.type.indexOf('Dome') >= 0) ? _c('visualization-pin-dome', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.visualizationPinSize.width,
      "height": _vm.visualizationPinSize.height,
      "transform": _vm.visualizationPinTransform,
      "is-searched": _vm.isVisualizationPinSearched,
      "is-selected": _vm.isVisualizationPinSelected
    }
  }) : _c('visualization-pin-defeult', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.visualizationPinSize.width,
      "height": _vm.visualizationPinSize.height,
      "transform": _vm.visualizationPinTransform,
      "is-searched": _vm.isVisualizationPinSearched,
      "is-selected": _vm.isVisualizationPinSelected
    }
  })], 1), _vm._v(" "), (_vm.isRestroom) ? _c('icon-full', {
    attrs: {
      "x": "0",
      "y": "0",
      "visualization-pin-size": _vm.visualizationPinSize,
      "visualization-pin-scale": _vm.visualizationPinScale,
      "is-searched": _vm.isVisualizationPinSearched,
      "is-selected": _vm.isVisualizationPinSelected,
      "spot": _vm.spot
    }
  }) : _vm._e(), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0",
      "y": _vm.textTop,
      "stroke": "#fff",
      "stroke-linejoin": "round",
      "stroke-width": _vm.borderSize,
      "font-size": _vm.textSize,
      "text-anchor": "middle"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.spot.name) + "\n  ")]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0",
      "y": _vm.textTop,
      "font-size": _vm.textSize,
      "text-anchor": "middle",
      "fill": "#6c6c6c",
      "font-weight": "bold"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.spot.name) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cebd1e08","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/pin/spot/base.vue
// module id = 742
// module chunks = 0